import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

import { Metamodel } from '../base/model';
import { format } from 'app/shared/utils/string.util';
import { OdbcLinkedService } from './odbc.linkedservice';
@Metamodel.model({
    name: adfModelTypeMap.microsoftAccess.linkedServiceType,
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.MicrosoftAccess_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.MicrosoftAccess_DisplayText)
    ]
})
export class MicrosoftAccessLinkedService extends OdbcLinkedService {

    constructor(name?: string, description?: string) {
        super(name, description);
    }
}
